import { render, staticRenderFns } from "./MassScript.vue?vue&type=template&id=0a4ca22a&"
import script from "./MassScript.vue?vue&type=script&lang=js&"
export * from "./MassScript.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports